import styled from 'styled-components';
import { palette } from '../styles';

export const MainDashboardSection = styled.section`
  .postsContainer {
    padding: 0px;
    margin: 12px 32px 12px 64px;
    display: flex;
    flex-wrap: wrap;
    font-family: 'Sofia Pro', sans-serif;
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;
    min-height: 100vh;
    width: 95%;
  }
  .actionsNav {
    width: 100%;
    display: flex;
    justify-content: space-between;
    background-color: ${(props) => (props.adminColor ? props.adminColor : '#234449')};
    padding: 64px;
    @media screen and (max-width: 1366px) {
      width: 98%;
    }
  }
  .leftNav {
    h1 {
      font-family: 'Cooper Md BT', serif;
      color: #fff;
      font-size: 32px;
      margin-bottom: 32px;
    }
  }
  .postTitle {
    font-size: 2.8rem;
    text-align: start;
    font-weight: 500;
    line-height: 32px;
    display: block;
    padding: 0;
    margin: 0;
  }
  .searchContainer {
    width: 294px;
    position: relative;
    border-radius: 4px;
    border: none;
  }
  .searchIcon {
    position: absolute;
    left: 15px;
    top: 17px;
    color: #fff;
    font-size: 1.7rem;
  }
  .searchInput {
    width: 100%;
    margin: auto !important;
    background-color: ${(props) => (props.adminColor ? '#212A70' : '#0f3f44')};
    border: none !important;
    padding: 7px 5px 6px 40px !important;
    font-size: 1.6rem !important;
    color: #fff;
    font-family: 'Sofia Pro', sans-serif;
    font-weight: 500;
    line-height: 21px;
    border-radius: 64px;
    &::placeholder {
      color: #fff;
    }
  }
  .rightNav {
    width: 35%;
    display: flex;
    justify-content: flex-end;
  }
  .createNew {
    width: 20%;
    display: contents;
    p {
      margin-right: 8px;
      margin-bottom: 16px;
      font-size: 16px;
      color: #fff;
      justify-self: end;
      align-self: flex-end;
    }
    button {
      background-color: #f69953;
      border: none;
      border-radius: 64px;
      width: 42px;
      height: 42px;
      position: relative;
      justify-self: end;
      align-self: flex-end;
      svg {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
  .divider {
    width: 100%;
    display: flex;
    height: 40px;
    align-items: center;
    justify-content: flex-start;
    margin: 55px auto 10px;
  }
  .dividerText {
    font-size: 2.5rem;
    width: auto;
    color: ${palette.black};
    margin: 0px auto;
  }
  .dividerLine {
    width: calc(100% - 240px);
    margin: 25px auto;
    //height: 2;
    background-color: ${palette.black};
    opacity: 0.5;
  }
  .cardsContainer {
    width: calc(100% - 65px);
    margin: 0px 30px;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: row;
    overflow-y: auto;
    height: 50%;
    overflow-x: auto;
    position: relative;
  }
  .editorContainer {
    width: 100%;
    display: flex;
    flex-wrap: nowrap;
    align-items: flex-start;
    justify-content: space-around;
  }
  .editor {
    width: 90%;
    min-height: 750px;
    background: #fff;
    margin: 0 auto;
    margin-top: 12px;
    border-radius: 16px;
  }
  .buttons-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    justify-content: space-between;
  }
  button {
    &:hover {
      cursor: pointer;
    }
  }
  .saveButtons-save {
    background: transparent;
    border: solid 1px #232323;
    margin-right: 8px;
  }
  .saveButtons-sub {
    background-color: ${(props) => (props.adminColor ? '#212A70' : '#234449')};
    color: #fff;
  }
  .cancelButton {
    background: transparent;
    border: solid 1px #232323;
  }
  .editorLabel {
    font-family: 'Cooper Md BT', sans-serif;
    font-size: 14px;
    margin-bottom: 6px !important;
    display: block;
  }
  .editorInput,
  .editorTextarea {
    margin-bottom: 8px;
    width: 100%;
  }
  .time {
    margin-bottom: 12px;
  }
  .ql-container.ql-snow {
    min-height: 550px;
    font-family: 'Sofia Pro', sans-serif;
    border: none;
  }
  .ql-editor.ql-blank::before {
    font-size: 18px;
  }
  .ql-editor {
    font-family: 'Sofia Pro', Sans-serif;
    h1 {
      font-size: 36px;
      font-weight: 400;
      font-family: 'Cooper Md BT', sans-serif;
    }
    h2 {
      font-size: 32px;
      font-weight: 400;
      font-family: 'Cooper Md BT', sans-serif;
    }
    h3 {
      font-size: 26px;
      font-weight: 400;
      font-family: 'Cooper Md BT', sans-serif;
    }
    p {
      font-size: 18px;
      line-height: calc(1ex / 0.25);
    }
    li {
      font-size: 16px;
      line-height: calc(1ex / 0.25);
      margin-top: 4px;
      font-family: 'Sofia Pro', sans-serif;
    }
    strong {
      font-family: 'Sofia Pro', sans-serif;
      font-size: 20px;
      font-weight: 700;
      p {
        font-family: 'Sofia Pro', sans-serif;
      }
    }
  }
  .imageBox {
    width: 100%;
    height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 10px auto;
    border: solid 1px #9a9a9e;
    border-radius: 7px;
  }
  .postImage {
    margin: auto;
    width: 45px;
    height: 45px;
    opacity: 0.4;
  }
  .uploadImage {
    width: auto;
    font-size: 1.6rem !important;
    color: white;
    background-color: ${(props) => (props.adminColor ? '#212A70' : '#234449')};
    border-radius: 2px;
  }
  .editImageButton {
    color: white;
    background-color: ${(props) => (props.adminColor ? '#212A70' : '#234449')};
    font-size: 1.6rem !important;
    text-align: center;
    margin: 0px;
    padding: 8px 16px;
    border-radius: 8px;
    font-family: 'Sofia Pro', sans-serif;
    font-weight: 500;
    margin-bottom: 16px;
  }
`;

export default null;
